module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5MDAiIGhlaWdodD0iNjAwIj48cGF0aCBmaWxsPSIjYzEyNzJkIiBkPSJNMCAwaDkwMHY2MDBIMHoiLz48cGF0aCBkPSJNNDUwIDIyNC4zMTVsLTQ0LjQ2NyAxMzYuODcgMTE2LjQwMS04NC41NTloLTE0My44N2wxMTYuNDAzIDg0LjU1OXoiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwNjIzMyIgc3Ryb2tlLXdpZHRoPSIxNC42MyIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/mar.svg
// module id = s9uv
// module chunks = 0